module.exports = __webpack_public_path__ + "static/media/img-appstore-btn.fa53b260.svg";